var indentation_default = {
  "indentZero": "_3wSyn",
  "indentOne": "VdJoV",
  "indentTwo": "UZuc-",
  "indentThree": "FjCw5",
  "indentFour": "auzQs",
  "indentFive": "JsubD",
  "indentSix": "_-81As"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
